(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  const select = selector => [...document.querySelectorAll(selector)];

  const groups = [
    { selector: '.site-header .brand', direction: 'left', start: 30 },
    { selector: '.site-header .main-nav', direction: 'down', start: 90 },
    { selector: '.site-header .search, .site-header .icon-btn, .site-header .cart-btn, .site-header .mobile-menu-toggle', direction: 'right', start: 135, stagger: 45 },
    { selector: '.catalogue-notice', direction: 'down', start: 190 },
    { selector: '#MainContent .hero', direction: 'up', start: 180 },
    { selector: '#MainContent .volt-category-filter', direction: 'left' },
    { selector: '#MainContent .volt-featured-products > header', direction: 'up' },
    { selector: '#MainContent .volt-home-product-card', direction: 'up', stagger: 55 },
    { selector: '#MainContent .volt-best-sellers', direction: 'right' },
    { selector: '#MainContent .trust-item', direction: 'up', stagger: 70 },
    { selector: '#MainContent .shopify-page-head, #MainContent .shopify-breadcrumb', direction: 'up', stagger: 65 },
    { selector: '#MainContent .shopify-product-card', direction: 'up', stagger: 45 },
    { selector: '#MainContent .collection-filter-panel', direction: 'right' },
    { selector: '#MainContent .product-gallery', direction: 'left' },
    { selector: '#MainContent .product-detail-copy', direction: 'right' },
    { selector: '#MainContent .product-description-shell', direction: 'up' },
    { selector: '#MainContent .generic-page-card, #MainContent .collection-index-card, #MainContent .blog-card', direction: 'up', stagger: 55 },
    { selector: '#MainContent .cart-heading, #MainContent .cart-products, #MainContent .cart-summary', direction: 'up', stagger: 70 },
    { selector: '#MainContent .account-heading, #MainContent .account-main, #MainContent .auth-card', direction: 'up', stagger: 70 },
    { selector: '#MainContent .contact-heading, #MainContent .help-heading, #MainContent .shipping-heading, #MainContent .terms-heading', direction: 'up' },
    { selector: '#MainContent .contact-sidebar, #MainContent .help-sidebar, #MainContent .shipping-side, #MainContent .terms-summary', direction: 'left' },
    { selector: '#MainContent .contact-form-panel, #MainContent .help-faq-panel, #MainContent .shipping-panel, #MainContent .terms-content', direction: 'right' },
    { selector: '.site-footer .footer-brand', direction: 'left' },
    { selector: '.site-footer .footer-column, .site-footer .footer-payments', direction: 'up', stagger: 70 },
    { selector: '.site-footer .footer-bottom', direction: 'up' }
  ];

  const entries = [];
  groups.forEach(group => {
    select(group.selector).forEach((element, index) => {
      if (entries.some(entry => entry.element === element)) return;
      const delay = Math.min((group.start || 0) + index * (group.stagger || 0), 420);
      element.classList.add('volt-reveal', `volt-reveal--${group.direction || 'up'}`);
      element.style.setProperty('--volt-reveal-delay', `${delay}ms`);
      entries.push({ element, delay });
    });
  });

  if (!entries.length) return;
  document.body.classList.add('volt-motion-initialized');

  const finish = entry => {
    window.setTimeout(() => {
      entry.element.classList.remove('volt-reveal', 'volt-reveal--up', 'volt-reveal--left', 'volt-reveal--right', 'volt-reveal--down', 'is-visible');
      entry.element.style.removeProperty('--volt-reveal-delay');
    }, 780 + entry.delay);
  };

  const reveal = entry => {
    if (entry.element.classList.contains('is-visible')) return;
    entry.element.classList.add('is-visible');
    finish(entry);
  };

  if (!('IntersectionObserver' in window)) {
    requestAnimationFrame(() => entries.forEach(reveal));
    return;
  }

  const observer = new IntersectionObserver(changes => {
    changes.forEach(change => {
      if (!change.isIntersecting) return;
      const entry = entries.find(item => item.element === change.target);
      if (entry) reveal(entry);
      observer.unobserve(change.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });

  entries.forEach(entry => observer.observe(entry.element));

  /* Sécurité : libère uniquement les éléments proches de l’écran si l’observateur tarde. */
  window.setTimeout(() => entries.forEach(entry => {
    const bounds = entry.element.getBoundingClientRect();
    if (!entry.element.classList.contains('is-visible') && bounds.top < window.innerHeight * 1.15) reveal(entry);
  }), 3500);
})();
